/**
 * loadingGif()
 *
 * Shows or hides a loading GIF element.
 *
 * @param {Element} element - The DOM element to show/hide the loading GIF.
 * @param {string} [action='show'] - The action to perform. Either "show" or "hide".
 * @param {number} [timeout=250] - The time in milliseconds to wait before hiding the loading GIF.
 * @returns {void}
 */
export function loadingGif(element, action = "show", timeout = 250) {
    if ((!element) instanceof Element) {
        console.log(`Error: ${element} is not a valid DOM element.`);
        return;
    }
    if (action === "show") {
        element.classList.add("show");
    } else if (action === "hide") {
        setTimeout(() => {
            element.classList.remove("show");
        }, timeout);
    } else {
        console.log(`Error: ${action} is not a valid action.`);
    }
}
